<template>
    <div class="dokan-video-popup" @click.self="closePopup">
        <div class="modal-content">
            <div class="body">
                <iframe :src="`https://www.youtube.com/embed/${videoId}`" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <span @click="closePopup" class="close">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.18849 5.00002L9.75385 1.43465C10.082 1.10645 10.082 0.574344 9.75385 0.246195C9.42566 -0.0820022 8.89359 -0.0820022 8.5654 0.246195L4.99998 3.81161L1.43457 0.246148C1.10637 -0.0820492 0.574308 -0.0820492 0.246112 0.246148C-0.0820373 0.574344 -0.0820373 1.10645 0.246112 1.4346L3.81153 4.99998L0.246112 8.5654C-0.0820373 8.89359 -0.0820373 9.4257 0.246112 9.75385C0.574308 10.082 1.10637 10.082 1.43457 9.75385L4.99998 6.18843L8.5654 9.75385C8.89355 10.082 9.42566 10.082 9.75385 9.75385C10.082 9.42566 10.082 8.89359 9.75385 8.5654L6.18849 5.00002Z" fill="#95A5A6"/>
                </svg>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "VideoPopup",

    props: {
        videoId: {
            type: String,
            required: true,
        }
    },

    methods: {
        closePopup() {
            this.$emit( 'toggle' );
        },
    },
}
</script>

<style lang="less">
.dokan-video-popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.7);
    z-index: 9999;
    overflow-y: auto;

    &::-webkit-scrollbar {
        display: none;
    }

    .modal-content {
        margin: 4% auto;
        max-width: 955px;
        text-align: center;
        position: relative;
        box-sizing: border-box;

        @media only screen and (max-width: 375px) {
            max-width: 340px;
            margin: 16% auto;
        }

        @media (min-width: 376px) and (max-width: 576px) {
            max-width: 360px;
            margin: 15% auto;
        }

        @media (min-width: 577px) and (max-width: 1024px) {
            max-width: 738px;
            margin: 8% auto;
        }

        span {
            &.close {
                position: absolute;
                top: -14px;
                right: -14px;
                cursor: pointer;
                background: #fff;
                border-radius: 50%;
                width: 30px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .body {
            iframe {
                background-color: #fff;
                border-radius: 5px;
                height: 525px;
                width: 100%;

                @media only screen and (max-width: 576px) {
                    height: 214px;
                }

                @media (min-width: 577px) and (max-width: 1023px) {
                    height: 395px;
                }

                @media (min-width: 1024px) and (max-width: 1200px) {
                    height: 405px;
                }
            }
        }
    }
}
</style>
